import { getToken } from './auth';

const config = window.pcaSettings;

async function request(path, method = 'GET', body) {
  const token = await getToken();
  if (!token) throw new Error('Not authenticated');
  const opts = {
    method,
    headers: { Authorization: `Bearer ${token}` },
    mode: 'cors'
  };
  if (body) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${config.api.uri}${path}`, opts);
  let data;
  try {
    data = await res.json();
  } catch (e) {
    data = undefined;
  }
  if (!res.ok) {
    const msg = (data && data.error) || res.statusText || 'Request failed';
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export function listAgentsWithEmails() {
  return request('/agents/emails');
}

export function updateAgentEmail(agentName, email, role, gmUsername, actorEmail) {
  return request(`/agents/${encodeURIComponent(agentName)}/email`, 'PUT', { email, role, gmUsername, actorEmail });
}

export function listActivityActors() {
  return request('/agents/activity');
}

export function getActorActivity(actor) {
  return request(`/agents/activity/${encodeURIComponent(actor)}`);
}
